export default __webpack_public_path__ + "static/media/headset11.ad569ca2.jfif";